import { doc, getDoc, setDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { INumber } from '@leedpulse-monorepo/interfaces';
import { cleanPhoneNumber } from '@leedpulse-monorepo/utils';

async function createNumber(
  payload: INumber,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new CreateNumberFailure('Unauthorized', 'unauthorized');
  }

  if (payload.sender === '' ||
    payload.group_id === '' ||
    payload.group_name === '') {
    throw new CreateNumberFailure('Les informations sont incomplètes');
  }

  try {
    const numberData: INumber = {
      available: payload.available,
      channel: payload.channel,
      connector_whatsapp: {},
      country: payload.country,
      created: payload.created,
      group_id: payload.group_id,
      group_name: payload.group_name,
      notes: payload.notes,
      product: payload.product,
      provider: payload.provider,
      redirection: cleanPhoneNumber(payload.redirection || ''),
      sender: payload.sender,
      updated: payload.created,
      ai_receptionist: { enabled: false, public_label: '', callback_label: '' },
    };

    const db = firestore;

    // First we check if the number already exists
    // If it does, we throw an error
    const numberRef = doc(db, FirestoreCollections.numbers, numberData.group_id);
    const numberSnap = await getDoc(numberRef);

    if (numberSnap.exists()) {
      throw new CreateNumberFailure('Number already exists', 'number-exists');
    }

    // If it doesn't, we create the number
    await setDoc(numberRef, numberData);

    return;
  } catch (e) {
    console.log('error: ', e);
    throw new CreateNumberFailure();
  }
}
export class CreateNumberFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default createNumber;
